<template>
  <el-dialog
    v-model="dialogFormVisible"
    title="设置员工权限"
    width="500px"
    @close="close"
  >
    <el-tree
      ref="tree"
      :data="data"
      :default-checked-keys="defaultCheckedKeys"
      node-key="permission"
      :props="defaultProps"
      show-checkbox
    />
    <template #footer>
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="save">确 定</el-button>
    </template>
  </el-dialog>
</template>

<script>
  import storejs from 'store'
  import {
    getAllAuthorities,
    getPeopleAllPermissions,
    setupPeoplePermission,
  } from '@/api/branch'

  export default {
    name: 'RoleSetupPermission',
    emits: ['fetch-data'],
    data() {
      return {
        peopleId: '',
        data: [],
        defaultProps: {
          children: 'children',
          label: 'label',
        },
        defaultCheckedKeys: [],
        dialogFormVisible: false,
      }
    },
    methods: {
      async getAllAuthorities() {
        const ret = await getAllAuthorities({
          scope: storejs.get('app').typehood,
        })
        ret.forEach((r) => {
          r.children.forEach((c, k) => {
            if (c.groupOnly && this.branchId) r.children.splice(k, 1)
          })
        })
        if (ret) this.data = ret
      },
      async getPeopleAllPermissions() {
        const ret = await getPeopleAllPermissions({
          peopleId: this.peopleId,
        })
        if (ret) {
          this.$refs.tree.setCheckedKeys(
            ret.map((e) => e.permission) || [],
            true
          )
        }
      },
      showSetupPermission(row) {
        this.peopleId = row && row.peopleId
        this.getAllAuthorities()
        this.getPeopleAllPermissions()
        this.dialogFormVisible = true
      },
      close() {
        this.dialogFormVisible = false
      },
      async save() {
        const permissionList = []
        this.$refs.tree.getCheckedNodes().forEach((e) => {
          if (e.permission) permissionList.push(e.permission)
        })
        this.loading = true
        let ret = await setupPeoplePermission({
          peopleId: this.peopleId,
          permissionList,
        })
        this.loading = false
        if (ret) {
          this.$message.success('设置员工权限成功')
          this.$emit('fetch-data')
          this.close()
        }
      },
    },
  }
</script>
